import { render } from "./BaseIcon.vue?vue&type=template&id=6d00d60c&scoped=true&ts=true"
import script from "./BaseIcon.vue?vue&type=script&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&lang=ts"

import "./BaseIcon.vue?vue&type=style&index=0&id=6d00d60c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d00d60c"]])

export default __exports__